import Instructions from 'components/game/module/engines/instructions/instructions';
import Image from 'components/game/module/engines/image/image';
import Order from 'components/game/module/engines/order/order';
import MultipleChoice from 'components/game/module/engines/multiple-choice/multiple-choice';
import SpotErrors from 'components/game/module/engines/spot-errors/spot-errors';
import Sort from 'components/game/module/engines/sort/sort';
import Match from 'components/game/module/engines/match/match';
import Dialogue from 'components/game/module/engines/dialogue/dialogue';
import BranchingStory from 'components/game/module/engines/branching-story/branching-story';

const moduleComponents = {
	instructions: Instructions,
	image: Image,
	'multiple-choice': MultipleChoice,
	order: Order,
	sort: Sort,
	'spot-errors': SpotErrors,
	match: Match,
	dialogue: Dialogue,
	'branching-story': BranchingStory
};

export {
	moduleComponents
};